export default "__VITE_ASSET__CFJ4x6uK__"